import { normalizeRelation } from './normalizeRelation';

export function getFamilyLabels(isRootGeneration, effectiveGeneration, rootHeadGenerationName) {
    let primaryLabel = "";
    let spouseLabel = "";
    let primaryRelation = "";
    let spouseRelation = "";

    console.log("getFamilyLabels input : \n isRootGeneration : ",isRootGeneration,"\n effectiveGeneration : ",effectiveGeneration,"\n rootHeadGenerationName : ",rootHeadGenerationName);

    // Helper: Relation to top ancestor
    const getRelationToRoot = (baseRelation, generation) => {
        if (generation === 1) return baseRelation; // Son / Daughter
        // Extract just "son" or "daughter" from baseRelation (handle if it's already "Grandson" etc.)
        const baseLower = baseRelation.toLowerCase();
        let core = baseLower;
        // Remove any "grand" prefix if present
        if (core.startsWith('grand')) {
            core = core.slice(5); // Remove "grand"
        }
        // Remove any "gr " or "great-" prefixes
        while (core.startsWith('gr ') || core.startsWith('great-')) {
            if (core.startsWith('gr ')) {
                core = core.slice(3);
            } else if (core.startsWith('great-')) {
                core = core.slice(6);
            }
        }
        
        if (generation === 2) {
            const result = "Grand" + core;
            return normalizeRelation(result);
        }
        if (generation >= 3) {
            const greatCount = generation - 2;
            const result = "Gr ".repeat(greatCount) + "Grand" + core;
            return normalizeRelation(result);
        }
        return baseRelation;
    };

    // Helper: Spouse label — only depends on base gender (no generation hierarchy)
    const getSpouseLabel = (baseRelation) => {
        return baseRelation === "Son" ? "Daughter-in-law" : "Son-in-law";
    };

    // Only show "Self" for generation 1 (root head)
    // isRootGeneration means no parent, which should be generation 1
    if (isRootGeneration) {
        primaryLabel = "Grandfather";
        spouseLabel = "Grandmother";
        // Only set "Self" if this is actually generation 1
        // When isRootGeneration is true, we're adding the root (generation 1)
        primaryRelation = "Self";
        spouseRelation = "Grandmother - Spouse";
    } else {
        primaryLabel = rootHeadGenerationName; // Son or Daughter
        primaryRelation = getRelationToRoot(rootHeadGenerationName, effectiveGeneration);
        spouseLabel = getSpouseLabel(rootHeadGenerationName); // fixed logic
        spouseRelation = getRelationToRoot(spouseLabel, effectiveGeneration);
    }

    console.log("getFamilyLabels output : \n primaryLabel : ",primaryLabel,"\n spouseLabel : ",spouseLabel,"\n primaryRelation : ",primaryRelation,"\n spouseRelation : ",spouseRelation);

    return {
        primaryLabel,
        spouseLabel,
        primaryRelation,
        spouseRelation,
    };
}


export function deriveSpouseRelationFromPrimary(primaryRelation) {
    if (!primaryRelation || typeof primaryRelation !== 'string') return 'Spouse';
    // let clean = primaryRelation.split(' - ')[0].trim().toLowerCase();
    const raw = primaryRelation.trim();
    const lowerRaw = raw.toLowerCase();
    // Handle top-of-line root head explicitly
    if (lowerRaw.startsWith('grandfather') && lowerRaw.includes('root head of family')) {
        return 'Grandmother - Spouse';
    }
    if (lowerRaw.startsWith('grandmother') && lowerRaw.includes('root head of family')) {
        return 'Grandfather - Spouse';
    }
    // Remove any trailing qualifiers like " - Root Head of Family"
    let clean = raw.split(' - ')[0].trim().toLowerCase();
    // Parse generation prefixes

    let greatCount = 0;
    while (clean.startsWith('great-') || clean.startsWith('gr ')) {
        greatCount++;
        // clean = clean.slice(6);
        if (clean.startsWith('great-')) {
            clean = clean.slice(6);
        } else if (clean.startsWith('gr ')) {
            clean = clean.slice(3);
        }
        console.log('After processing prefix, clean:', clean);
    }
    let hasGrand = false;
    if (clean.startsWith('grand')) {
        hasGrand = true;
        clean = clean.slice(5);
    }

    if (clean.startsWith('-')) clean = clean.slice(1);
    const isMaleLine = clean.includes('son');
    const spouseBase = isMaleLine ? 'daughter-in-law' : 'son-in-law';
    // const prefix = hasGrand ? ((greatCount > 0 ? 'Great-'.repeat(greatCount) : '') + 'Grand') : '';
    const prefix = hasGrand ? ((greatCount > 0 ? 'Gr '.repeat(greatCount) : '') + 'Grand') : '';
    const combined = prefix ? `${prefix}${spouseBase}` : spouseBase;
    // Ensure proper capitalization - only first letter should be uppercase
    return combined.charAt(0).toUpperCase() + combined.slice(1);
}

export const formatFullName = (first, spouse, last) => {
  const f = first || "";
  const s = spouse ? ` & ${spouse}` : "";
  const l = last ? ` ${last}` : "";

  return `${f}${s}${l}`.trim();
};



